import { Breadcrumbs, Link, Typography } from '@mui/material'
import { useNavigate } from 'react-router'
import * as AppRoutes from 'Pages/Routes'

interface ReportHeaderProps {
  title: string
}

export function ReportHeader (props: ReportHeaderProps): JSX.Element {
  const nav = useNavigate()

  const backToList = (): void => {
    nav(AppRoutes.REPORTS)
  }

  return (
    <>
      <Typography variant="h3" sx={{ mb: 2 }}>{props.title}</Typography>
      <Breadcrumbs maxItems={1} aria-label="breadcrumb" sx={{ mb: 2 }}>
        <Link component="button" sx={{ cursor: 'pointer' }} underline="hover" color="inherit" onClick={backToList}>
          Return
        </Link>
      </Breadcrumbs>
    </>
  )
}
